<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Product Information</div>
      </div>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-flex xs12 class="mt-3">
        <message :messages="messages"></message>
      </v-flex>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6 v-if="newProduct">
            <v-text-field :label="labels.product" v-model="productForm.product" :error-messages="errors.collect('product')" v-validate="'required|param|max:12'" data-vv-name="product" :data-vv-as="labels.product"></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{labels.productQuery}}</v-subheader>
            <div class="title">{{productForm.product}}</div>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.desc" v-model="productForm.desc" :error-messages="errors.collect('desc')" v-validate="'required|entry|max:128'" data-vv-name="desc" :data-vv-as="labels.desc"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-autocomplete :items="polTypeList" v-model="productForm.defPolType" :label="labels.defPolType" item-text="label" item-value="value" data-vv-name="defPolType" :data-vv-as="labels.defPolType" :error-messages="errors.collect('defPolType')" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.backDateAcceptDays" v-model="productForm.backDateAcceptDays" :error-messages="errors.collect('backDateAcceptDays')" v-validate="'numeric|max:10'" data-vv-name="backDateAcceptDays" :data-vv-as="labels.backDateAcceptDays"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.maxDaysBeforeCover" v-model="productForm.maxDaysBeforeCover" :error-messages="errors.collect('maxDaysBeforeCover')" v-validate="'numeric|max:10'" data-vv-name="maxDaysBeforeCover" :data-vv-as="labels.maxDaysBeforeCover"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.maxDaysCovered" v-model="productForm.maxDaysCovered" :error-messages="errors.collect('maxDaysCovered')" v-validate="'numeric|max:10'" data-vv-name="maxDaysCovered" :data-vv-as="labels.maxDaysCovered"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-checkbox :label="labels.isTakaful" v-model="productForm.isTakaful" data-vv-name="isTakaful" :data-vv-as="labels.isTakaful"></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-checkbox :label="labels.inclGst" v-model="productForm.inclGst" data-vv-name="inclGst" :data-vv-as="labels.inclGst"></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.defBrn" v-model="productForm.defBrn" data-vv-name="branch" :data-vv-as="labels.defBrn"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-checkbox :label="labels.finInstOptCvr" v-model="productForm.finInstOptCvr" data-vv-name="finInstOptCvr" :data-vv-as="labels.finInstOptCvr"></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.polWordingUrl" v-model="productForm.polWordingUrl" :error-messages="errors.collect('polWordingUrl')" v-validate="'url|max:128'" data-vv-name="polWordingUrl" :data-vv-as="labels.polWordingUrl"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.brochureUrl" v-model="productForm.brochureUrl" :error-messages="errors.collect('brochureUrl')" v-validate="'url|max:128'" data-vv-name="brochureUrl" :data-vv-as="labels.brochureUrl"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea auto-grow box rows="3" :label="labels.b2cTnc" v-model="productForm.b2cTnc" :error-messages="errors.collect('b2cTnc')" v-validate="'entry'" data-vv-name="b2cTnc" :data-vv-as="labels.b2cTnc"></v-textarea>
          </v-flex>
          <v-flex xs12 v-if="productAppID === 'TR'">
            <v-textarea auto-grow box rows="3" :label="labels.ciFooter" v-model="productForm.ciFooter" :error-messages="errors.collect('ciFooter')" v-validate="'entry|max:1000'" data-vv-name="ciFooter" :data-vv-as="labels.ciFooter"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
              {{newProduct? 'Add product' : 'Update product'}}
              <v-icon right>{{newProduct? 'mdi-calendar-plus' : 'mdi-content-save'}}</v-icon>
              </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { appID } from '@/const/underwriting'
export default {
  data() {
    return {
      labels: {
        product: 'Product Code*',
        desc: 'Description*',
        productQuery: 'Product Code',
        defPolType: 'Default Policy Type',
        backDateAcceptDays: 'Back Date Accept Days',
        maxDaysBeforeCover: 'Max Days Before Cover',
        maxDaysCovered: 'Max Days Covered',
        finInstOptCvr: 'Financial Institution Option Covered',
        polWordingUrl: 'Policy Wording Url',
        brochureUrl: 'Brochure Url',
        b2cTnc: 'B2C TNC',
        isTakaful: 'Is Takaful',
        inclGst: 'Included GST',
        defBrn: 'Default Branch',
        ciFooter: 'CI Footer Text'
      },
      productForm: {
        product: null,
        desc: null,
        appId: null,
        defPolType: null,
        backDateAcceptDays: null,
        maxDaysCovered: null,
        finInstOptCvr: false,
        polWordingUrl: null,
        brochureUrl: null,
        b2cTnc: null,
        isTakaful: false,
        inclGst: false,
        defBrn: null,
        ciFooter: null,
        revision: null
      },
      menu: [],
      polTypeList: [],
      newProduct: false,
      submitting: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    expDateValidation() {
      return 'required|start_enddate:' + this.productForm.effDate
    },
    productMenu() {
      return this.$store.state.productManagement.product.menu
    },
    productAppID() {
      return this.$store.state.parameters.appID
    }
  },
  methods: {
    ...mapActions([
      'productInit'
    ]),
    async doInit() {
      if (this.$store.state.productManagement.product.init !== 1) {
        await this.$store.dispatch('productMenuInit', this.product)
      }
      if (!this.newProduct) {
        // Review
        await this.reviewproduct(this.product)
      }
    },
    async reviewproduct(xproduct) {
      const apiURI = this.productMenu.productGet
      this.newProduct = false
      if (apiURI) {
        try {
          const expand = {
            product: xproduct
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.polTypeList = data.polTypeList
          if (data) {
            // product init
            this.productForm.product = data.product.product
            this.productForm.desc = data.product.desc
            this.productForm.appId = data.product.appId
            this.productForm.defPolType = data.product.defPolType
            this.productForm.backDateAcceptDays = data.product.backDateAcceptDays
            this.productForm.maxDaysBeforeCover = data.product.maxDaysBeforeCover
            this.productForm.maxDaysCovered = data.product.maxDaysCovered
            this.productForm.finInstOptCvr = data.product.finInstOptCvr
            this.productForm.polWordingUrl = data.product.polWordingUrl
            this.productForm.brochureUrl = data.product.brochureUrl
            this.productForm.b2cTnc = data.product.b2cTnc
            this.productForm.isTakaful = data.product.isTakaful
            this.productForm.inclGst = data.product.inclGst
            this.productForm.defBrn = data.product.defBrn
            this.productForm.ciFooter = data.product.ciFooter
            this.productForm.revision = data.product.revision
            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL - Review Product')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newProduct) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.menu.productUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.productForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.reviewproduct(this.productForm.product)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Update')
      }
    },
    async doCreate() {
      const apiURI = this.$store.state.productManagement.menu.createProduct
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.productForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)

            // Stay on page
            this.newProduct = false
            switch (this.productAppID) {
              case appID.MOTOR: {
                this.$router.push({ name: 'motorProductList' })
                break
              }
              case appID.TRAVEL: {
                this.$router.push({ name: 'travelProductList' })
                break
              }
              case appID.FIRE: {
                this.$router.push({ name: 'fireProductList' })
                break
              }
              case appID.CARGO: {
                this.$router.push({ name: 'cargoProductList' })
                break
              }
              case appID.MAID: {
                this.$router.push({ name: 'maidProductList' })
                break
              }
              case appID.PACKAGE: {
                this.$router.push({ name: 'packageProductList' })
                break
              }
              case appID.PA: {
                this.$router.push({ name: 'paProductList' })
                break
              }
              default: {
                this.$snotify.error('Invalid APPID')
              }
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Create')
      }
    },
    async polTypeListInit() {
      const apiURI = this.$store.state.productManagement.menu.polTypeList
      if (apiURI) {
        try {
          const expand = {
            appId: this.productAppID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.polTypeList = data
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL - Policy Type List')
      }
    }
  },
  mounted() {
    if (this.product === 'new') {
      this.newProduct = true
      this.productForm.appId = this.productAppID
      this.polTypeListInit()
    } else {
      this.doInit()
    }
  },
  props: {
    product: {
      type: String,
      default: ''
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>
